import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { Button, Spacer, Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { Input } from 'src/sites/kits/Utils/ConnectedForm'
import { Title } from 'src/sites/kits/UI'
import { useLocationQuery } from 'src/sites/kits/Utils'
import apiFetch from 'src/sites/kits/Utils/apiFetch'
import AccountContainer from '~/components/Container'

const CancelAccountDeletion = () => {
   const [error, setError] = useState(false)
   const [cancellationIsComplete, setCancellationIsComplete] = useState(false)
   const { code, email, requestId } = useLocationQuery()

   const handleSubmit = async (values, actions) => {
      try {
         setError(null)
         const response = await apiFetch('/users/account-deletion/cancel', {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({ requestId, code, email })
         })

         if (response.ok) {
            setCancellationIsComplete(true)
         } else {
            const result = await response.json()
            setError(result?.message || 'An unexpected error occurred')
         }
      } catch (err) {
         setError(err.message)
      } finally {
         actions.setSubmitting(false)
      }
   }

   if (!email || !code || !requestId) {
      return (
         <AccountContainer overrideLoginCheck>
            <Text size="3[a-d] 3[e-f]" color="red">
               {'Invalid Link'}
            </Text>
         </AccountContainer>
      )
   }

   return (
      <AccountContainer overrideLoginCheck>
         {cancellationIsComplete && (
            <>
               <Title size="lg">
                  Account Deletion Cancelled
               </Title>
               <Spacer size="2" />
               <Text size="3[a-d] 3[e-f]" color="#666">
                  {'Your request has been cancelled successfully.'}
               </Text>
            </>
         )}
         {!cancellationIsComplete && (
            <Formik
               onSubmit={handleSubmit}
               render={({ isSubmitting }) => (
                  <Form>
                     <Title size="xl">
                        Cancel Account Deletion
                     </Title>
                     <View float="left" width="100%" height="12px" />
                     <Text size="3[a-d] 3[e-f]" color="#666">
                        Click the button below to cancel your account deletion request.
                     </Text>
                     <View float="left" width="100%" height="30px" />
                     {error && (
                        <Text color="red">{error}</Text>
                     )}
                     <View
                        float="left"
                        width="100%"
                        display="flex"
                        flexFlow="column[a-b] row[c-f]"
                        justifyContent="flex-start"
                        alignItems="center">
                        <Button
                           type="submit"
                           mode={isSubmitting ? 'loading' : 'normal'}
                           name="Cancel Account Deletion"
                           width="100%[a-b] auto[c-f]"
                           rounded
                        />
                     </View>
                  </Form>
               )}
            />
         )}
      </AccountContainer>
   )
}

export default CancelAccountDeletion

